import{theme as r}from"./theme.js";var o=function(o){if(o){var t=o.split("."),e=t[0],i=t[1];return r.color[e][i]}};export{o as getSemanticColor};
//# sourceMappingURL=getSemanticColor.js.map
